import { render } from "./GuestNameBar.vue?vue&type=template&id=2bbf6e5f"
import script from "./GuestNameBar.vue?vue&type=script&lang=js"
export * from "./GuestNameBar.vue?vue&type=script&lang=js"

import "./GuestNameBar.vue?vue&type=style&index=0&id=2bbf6e5f&lang=css"
import "./GuestNameBar.vue?vue&type=style&index=1&id=2bbf6e5f&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__